import { render, staticRenderFns } from "./UserWallet.vue?vue&type=template&id=2c7a1fbd&scoped=true"
import script from "./UserWallet.vue?vue&type=script&lang=js"
export * from "./UserWallet.vue?vue&type=script&lang=js"
import style0 from "./UserWallet.vue?vue&type=style&index=0&id=2c7a1fbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7a1fbd",
  null
  
)

export default component.exports